import { Component, HostListener, OnInit } from '@angular/core';
import * as $ from 'jquery';
import { FooterComponent } from '../footer/footer.component';
import { RouterOutlet } from '@angular/router';
import { SidenavComponent } from '../sidenav/sidenav.component';
import { HeaderComponent } from '../header/header.component';
import { Subscription } from 'rxjs';
import { CommonService } from '../../Common/common.service';
import { LoginService } from '../../services/login.service';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-common-layout',
    templateUrl: './common-layout.component.html',
    styleUrls: ['./common-layout.component.css'],
    standalone: true,
    imports: [HeaderComponent, SidenavComponent, RouterOutlet, FooterComponent]
})
export class CommonLayoutComponent implements OnInit {

  _sub: Subscription
  _showLayout: boolean = false;
  constructor(private router: Router, private commonService: CommonService, private loginService: LoginService) { }


  ngOnInit() {
    //if ($("#layoutSidenav_nav").hasClass("sidenav-show-hide")) {
    //  $("#sidebarToggle").removeClass("is-active");
    //}
    //else {
    //  $("#sidebarToggle").addClass("is-active");
    //}
    debugger
    this.loginService.Login();
    var windowsize = $(window).width();
    if ((windowsize <= 801) && $("#layoutSidenav_nav").show()) {
      $("#layoutSidenav_nav").hide();
      // alert(0);
    }
    this._sub = this.commonService.showLayout$.subscribe((data: boolean) => {
      if (data == true) {
        this._showLayout = data
      }
    })

  }

  closeOpensidenNav() {
    var windowsize = $(window).width();
    if ((windowsize <= 801) && $("#layoutSidenav_nav").show()) {
      $("#layoutSidenav_nav").hide();
    }
  }

  @HostListener('window:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    let value = event.which;
    if (value == 112) {
      window.open("help", "", "width=800,height=1000");
    }
  }

}
